import {Button} from 'shells/button/button';
import {IconButton} from 'shells/button/icon-button/icon-button';
import {ChevronLeftIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

import styles from './sidebar-panel-header.module.css';

interface Props {
    title: string;
    onBack?: () => void;
    onDone?: () => void;
}

export function SidebarPanelHeader(props: Props) {
    return (
        <div className='flex align-center py-8'>
            <div className={styles['header-layout-block']}>
                {props.onBack && (
                    <IconButton
                        icon={ChevronLeftIcon}
                        onClick={props.onBack}
                        noHoverBackground={true}
                    />
                )}
            </div>
            <div className={styles['header-text-center']}>
                <Body isBold={true}>{props.title}</Body>
            </div>
            <div className={styles['header-layout-block']}>
                {props.onDone && (
                    <Button variant='text-secondary' size='small' onClick={props.onDone}>
                        Done
                    </Button>
                )}
            </div>
        </div>
    );
}
